module.exports = __webpack_public_path__ + "img/colorful1-start.1b673ed4.png";